module.exports = __webpack_public_path__ + "img/case_sensitive_selected.65efbd83.svg";